import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchSchemasForTaxYearTypes = getApiActionTypes('REPORTS/FETCH_SCHEMAS_FOR_TAX_YEAR');
export const fetchSchemasCompareReportTypes = getApiActionTypes(
  'REPORTS/FETCH_SCHEMAS_COMPARE_REPORT',
);
